import { Link } from "react-router-dom";

const entries = [
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "动漫资讯",
    desc: "追踪最新动漫动态、活动与预告，掌握第一手情报。",
    accent: "bg-primary-500",
    tag: "实时更新",
  },
  {
    to: "/recommend",
    icon: "ri-movie-2-line",
    title: "热门动漫作品",
    desc: "按类型、地区、年代浏览精选作品，发现你的下一部心头好。",
    accent: "bg-accent-500",
    tag: "多维筛选",
  },
  {
    to: "/special",
    icon: "ri-stack-line",
    title: "专题推荐",
    desc: "跟随专题片单系统回顾与探索，让追番更有方向。",
    accent: "bg-secondary-600",
    tag: "精选片单",
  },
];

export default function QuickLinks() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
        {entries.map((e, i) => (
          <Link
            key={e.to}
            to={e.to}
            className={`group animate-rise-in anim-delay-${i + 1} flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6`}
          >
            <div className="flex items-center justify-between">
              <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${e.accent} text-white`}>
                <i className={`${e.icon} text-2xl`} />
              </span>
              <span className="rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-600">
                {e.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{e.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{e.desc}</p>
            <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
              进入板块
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}